const initialState = {
  favorites: []
}

const userConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'STORE_ME_READ_ALL':
    case 'STORE_ME_UPDATE':
      return {
        ...(state.user_id === action.result.user_id ? state : initialState),
        user_id: action.result.user_id,
        favorites: action.result.favorites || []
      }
    case 'STORE_USER/CONFIG_READ_ALL':
    case 'STORE_USER/CONFIG_SEARCH':
      return {
        favorites: action.result
          .filter(fav => fav.user_id !== state.user_id)
      }
    case 'STORE_USER/CONFIG_CREATE':
      return {
        favorites: state.favorites.concat([action.result])
      }
    case 'STORE_USER/CONFIG_DELETE':
      return {
        favorites: state.favorites
          .filter(fav => !(
            fav.user_id === action.result.user_id &&
            fav.name === action.result.name &&
            fav.section === action.result.section &&
            fav.value === action.result.value
          ))
      }
    default:
      return state
  }
}

export default userConfigReducer
